module.exports = __webpack_public_path__ + "static/media/oculus.64c8bee7.svg";